import ExploreServiceSort from '../types/ExploreServiceSort';

export const defaultExploreServiceSort: ExploreServiceSort = 'best_match';
export const exploreServiceSortDisplayOrder: ExploreServiceSort[] = ['best_match', 'most_popular', 'closest', 'seasonal', 'newly_added'];
